<template>
  <div>
    <div class="top_banner">
      <div class="banner_category">
        <img :src="require(`@/assets/banner_car-rental.jpg`)" />
      </div>
      <div class="name_page">
        <h1>包車及接送</h1>
      </div>
    </div>
    <div class="narrow_container">
      <Breadcrumb page="包車及接送" />
      <div
        style="
          margin: auto;
          text-align: center;
          height: 360px;
          padding: 100px;
          position: relative;
        "
        v-if="loading"
      >
        <Loading />
      </div>
      <template v-else>
        <div class="page_desc">
          我們提供各種租車服務，包括包車服務（自訂行程）和包車服務（精選行程），你可以按照喜好和需要選擇不同的服務，與家人、旅伴享受私人的渡假時光
        </div>
        <div class="page_subcat_list">
          <div
            class="page_subcat"
            v-for="(item, idx) in carRentalService"
            :key="idx"
            @click.stop="routeTo(item.pk)"
          >
            <div class="page_subcat_img">
              <img :src="item.imagePath" />
            </div>
            <div class="page_subcat_txt">
              <p>
                <b>{{ item.name }}</b>
              </p>
              <p>{{ item.intro }}</p>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="bottom_txt">
      EGL Tours 的租車服務包括兩大範疇：包車服務（自訂行程）和包車服務（精選行程）。包車服務適合沒有駕駛執照，或不想為開車而煩惱的人士，全程由當地經驗司機代勞，安坐車中就能輕鬆到達目的地，而行走路線可完全由閣下決定（自訂行程），或採用由經驗團隊設計的路線（精選行程）。
    </div>
  </div>
</template>

<script>
import { ref, onBeforeMount, onMounted } from "vue";
import CmsApiService from "@/services/CmsApiService.js";
import router from "@/router";
import useEventBus from "@/config/eventBus";

export default {
  setup() {
    const loading = ref(true);
    const eventBus = useEventBus();
    const carRentalService = ref([]);

    const routeTo = (id) => {
      switch (id) {
        case 1:
          router.push("/product/car-rental");
          break;
        case 2:
          router.push("/product/ground-transfer");
          break;
        case 3:
          router.push("/product/coach-hire-suggest");
          break;
        case 4:
          router.push("/product/coach-hire-custom");
          break;
      }
    };

    onBeforeMount(() => {
      eventBus.emit("showSearchIcon", true);
      eventBus.emit("hideSearchBar");
    });

    onMounted(() => {
      CmsApiService.getCarRentalSummary().then((res) => {
        console.log(res);
        if (res.success === 1) {
          if (res.data.length > 0) {
            carRentalService.value = res.data;
            //carRentalService.value = res.data.filter((el) => el.id != "2");
            setTimeout(() => {
              loading.value = false;
            }, 100);
          }
        }
      });
    });

    return { loading, carRentalService, routeTo };
  },
};
</script>